<template>
    <div>
        <zm-button size="small" @click="showCreate()" class="btn-in-line" type="primary" v-if="hasPermission">create service region</zm-button>
        <zm-table :data="list.slice((pageable.page - 1) * pageable.size, pageable.page * pageable.size)" v-loading="loading">
            <zm-table-column label="Name" prop="name"></zm-table-column>
            <zm-table-column label="Description" prop="description"></zm-table-column>
            <zm-table-column prop="operation" width="300px">
                <template slot-scope="scope">
                    <zm-button type="icon" icon="zm-icon-edit" @click="showEdit(scope.row)" v-if="hasPermission"></zm-button>
                    <zm-button type="icon" icon="zm-icon-copy" @click="showDuplicate(scope.row)" v-if="hasPermission"></zm-button>
                    <zm-button type="icon" icon="zm-icon-delete" @click="showDelete(scope.row.id)" v-if="hasPermission"></zm-button>
                    <zm-button type="icon" icon="zm-icon-move-to" @click="showApp(scope.row)"></zm-button>
                    <!-- <zm-dropdown class="btn-contain" style="margin-left: 10px;" @command="handleCommand">
                        <zm-button type="icon" icon="zm-icon-more" class="btn-contain"></zm-button>
                        <zm-dropdown-menu slot="dropdown">
                            <zm-dropdown-item :command="{command: 'showApp', param: scope.row}">
                                Show App
                            </zm-dropdown-item>
                            <zm-dropdown-item :command="{command: 'showClient', param: scope.row}">
                                Show Client
                            </zm-dropdown-item>
                            <zm-dropdown-item :command="{command: 'showResult', param: scope.row}">
                                Show Result
                            </zm-dropdown-item>
                        </zm-dropdown-menu>
                    </zm-dropdown> -->
                    <zm-button type="icon" icon="zm-icon-device-directory" title="show client" @click="showClient(scope.row)"></zm-button>
                    <zm-button type="icon" icon="zm-icon-info" title="show result" @click="showResult(scope.row)"></zm-button>
                </template>
            </zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination
                :current-page.sync="pageable.page" :page-size="pageable.size"
                layout="total, prev, pager, next"
                :total="list.length">
            </zm-pagination>
        </div>
        <zm-dialog :title="form.title" :visible.sync="visible">
            <zm-form ref="form" :model="form" :rules="rules" label-width="120px">
                <zm-form-item prop="name">
                    <div slot="label">
                        <tip label="Name" id="smart-serviceregion-name"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.name"></zm-input>
                </zm-form-item>
                <zm-form-item label="dc" prop="dc">
                    <div slot="label">
                        <tip label="Dc" id="smart-serviceregion-dc"></tip>
                    </div>
                    <zm-select size="small" v-model="form.dc" clearable style="width: 100%">
                        <zm-option v-for="item in dcs" :key="item.id" :value="item.dcName" :label="item.dcName"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="description">
                    <div slot="label">
                        <tip label="Description" id="smart-serviceregion-description"></tip>
                    </div>
                    <zm-input size="small" type="textarea" v-model="form.description"></zm-input>
                </zm-form-item>
                <zm-form-item label-width="0px">
                    <zm-checkbox v-model="form.openSetting" @change="onOpenSettingChange">
                        <tip label="Setting" id="smart-serviceregion-openSetting"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <div class="param-wrapper" v-if="form.openSetting" v-loading="form.settingLoading">
                <zm-form-item prop="strategy">
                    <div slot="label">
                        <tip label="Strategy" id="smart-serviceregion-strategy"></tip>
                    </div>
                    <zm-select size="small" v-model="form.settingParam.strategy" style="width: 100%">
                        <zm-option v-for="item in Object.keys(strategyList)" :key="item" :label="strategyList[item]" :value="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="counts" label-width="180px">
                    <div slot="label">
                        <tip label="Counts" id="smart-serviceregion-counts"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.settingParam.counts" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item prop="maxWorkersPerCpu" label-width="180px">
                    <div slot="label">
                        <tip label="Max Workers Per Cpu" id="smart-serviceregion-maxWorkersPerCpu"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.settingParam.maxWorkersPerCpu" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item prop="receiveCounts" label-width="180px">
                    <div slot="label">
                        <tip label="Receive Counts" id="smart-serviceregion-receiveCounts"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.settingParam.receiveCounts" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item prop="requiredMinInstances" label-width="180px">
                    <div slot="label">
                        <tip label="Required Min Instances" id="smart-serviceregion-requiredMinInstances"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.settingParam.requiredMinInstances" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label-width="0px">
                    <zm-checkbox v-model="form.settingParam.active">
                        <tip label="Active" id="smart-serviceregion-active"></tip>
                    </zm-checkbox>
                </zm-form-item>
                </div>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="form.settingLoading || loading">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listPool, createPool, updatePool, deletePool, listServiceById, listStrategy, duplicatePool } from '@/api/smart'
import { getChannelDcs } from '@/api'
import tip from 'components/ToolTip/index'
export default {
    name: 'service',
    components: {
        tip
    },
    data () {
        return {
            role: localStorage.role,
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            loading: false,
            serviceId: '',
            list: [],
            dcs: [],
            visible: false,
            strategyList: [],
            form: {
                title: '',
                id: '',
                name: '',
                description: '',
                dc: '',
                serviceName: '',
                openSetting: false,
                settingLoading: false,
                settingParam: {
                    active: false,
                    counts: 0,
                    maxWorkersPerCpu: 0,
                    receiveCounts: 0,
                    requiredMinInstances: 0,
                    strategy: ''
                }
            },
            pageable: {
                page: 1,
                size: 10,
                total: 0
            },
            rules: {
                name: [
                    { required: true, message: 'please enter name', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.serviceId = this.$route.params.id
        this.form.serviceName = this.$route.params.name
        this.fetchData()
        this.fetchDcs()
    },
    methods: {
        fetchDcs () {
            getChannelDcs().then(response => {
                this.dcs = response
            })
        },
        fetchStrategy () {
            listStrategy().then(response => {
                this.strategyList = response
            })
        },
        fetchSetting () {
            this.form.settingLoading = true
            listServiceById(this.serviceId).then(response => {
                this.form.settingParam.active = response.setting.active
                this.form.settingParam.counts = response.setting.counts
                this.form.settingParam.maxWorkersPerCpu = response.setting.maxWorkersPerCpu
                this.form.settingParam.receiveCounts = response.setting.receiveCounts
                this.form.settingParam.requiredMinInstances = response.setting.requiredMinInstances
                this.form.settingParam.strategy = response.setting.strategy
                this.form.settingLoading = false
            }).catch(() => {
                this.form.settingLoading = false
            })
        },
        onOpenSettingChange (val) {
            if (val) {
                this.fetchSetting()
            } else {
                this.form.settingParam.active = null
                this.form.settingParam.counts = null
                this.form.settingParam.maxWorkersPerCpu = null
                this.form.settingParam.receiveCounts = null
                this.form.settingParam.requiredMinInstances = null
                this.form.settingParam.strategy = null
            }
        },
        showCreate () {
            this.fetchStrategy()
            this.form.title = 'Create Service Region'
            this.form.id = ''
            this.form.name = ''
            this.form.dc = ''
            this.form.description = ''
            this.form.settingParam.active = null
            this.form.settingParam.counts = null
            this.form.settingParam.maxWorkersPerCpu = null
            this.form.settingParam.receiveCounts = null
            this.form.settingParam.requiredMinInstances = null
            this.form.settingParam.strategy = null
            this.form.openSetting = false
            this.visible = true
        },
        showEdit (row) {
            this.fetchStrategy()
            this.form.title = 'Edit Service Region'
            this.form.id = row.id
            this.form.name = row.name
            this.form.dc = row.dc
            this.form.description = row.description
            this.form.openSetting = false
            if (row.setting) {
                this.form.settingParam.active = row.setting.active
                this.form.settingParam.counts = row.setting.counts
                this.form.settingParam.maxWorkersPerCpu = row.setting.maxWorkersPerCpu
                this.form.settingParam.receiveCounts = row.setting.receiveCounts
                this.form.settingParam.requiredMinInstances = row.setting.requiredMinInstances
                this.form.settingParam.strategy = row.setting.strategy
                this.form.openSetting = true
            }
            this.visible = true
        },
        showDuplicate (row) {
            this.fetchStrategy()
            this.form.title = 'Duplicate Service Region'
            this.form.id = row.id
            this.form.name = 'Copy_' + row.name
            this.form.dc = row.dc
            this.form.description = row.description
            this.form.openSetting = false
            if (row.setting) {
                this.form.settingParam.active = row.setting.active
                this.form.settingParam.counts = row.setting.counts
                this.form.settingParam.maxWorkersPerCpu = row.setting.maxWorkersPerCpu
                this.form.settingParam.receiveCounts = row.setting.receiveCounts
                this.form.settingParam.requiredMinInstances = row.setting.requiredMinInstances
                this.form.settingParam.strategy = row.setting.strategy
                this.form.openSetting = true
            }
            this.visible = true
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const { title, id, name, dc, description, serviceName, settingParam, openSetting } = this.form
                    const data = openSetting ? { name, dc, description, serviceName, settingParam } : { name, description, serviceName }
                    if (title === 'Edit Service Region') {
                        this.loading = true
                        updatePool(id, data).then(() => {
                            this.loading = false
                            this.visible = false
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else if (title === 'Create Service Region') {
                        this.loading = true
                        createPool(data).then(() => {
                            this.loading = false
                            this.visible = false
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        this.loading = true
                        duplicatePool(id, data).then(() => {
                            this.loading = false
                            this.visible = false
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                }
            })
        },
        showClient (row) {
            this.$router.push('/dashboard/smart/' + this.$route.params.name + '/' + row.name + '/client/' + this.serviceId + '/' + row.id)
        },
        showDelete (id) {
            this.$confirm('This will permanently delete the service region. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deletePool(id).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Delete service region success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        showApp (row) {
            this.$router.push('/dashboard/smart/' + this.form.serviceName + '/' + row.name + '/application/' + this.serviceId + '/' + row.id)
        },
        showResult (row) {
            this.$router.push({
                path: '/dashboard/smart/result',
                query: {
                    serviceId: this.serviceId,
                    serviceName: this.form.serviceName,
                    poolId: row.id,
                    poolName: row.name
                }
            })
        },
        handleCommand (command) {
            if (command.command === 'showApp') {
                this.showApp(command.param)
            } else if (command.command === 'showClient') {
                this.showClient(command.param)
            } else if (command.command === 'showResult') {
                this.showResult(command.param)
            }
        },
        fetchData () {
            this.loading = true
            listPool(this.serviceId).then(response => {
                this.list = response
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
<style>
.param-wrapper {
    border: solid 1px rgba(195, 195, 195, 0.5);
    border-radius: 8px;
    padding: 10px;
}
</style>
